import React from "react";
import { Button } from "antd";
import { title } from "../Constants";

class StepsHeader extends React.Component {
  render() {
    const { currentStep, NextPrevSteps, resetFields } = this.props;
    return currentStep === 0 ? (
      <div className="form_header">
        <Button
          className="float-right"
          htmlType="button"
          onClick={() =>
            NextPrevSteps(currentStep === 0 ? title.Next : title.Previous)
          }
        >
          {currentStep === 0 ? title.Next : title.Previous}
        </Button>

        <Button type="link" className="float-right" onClick={resetFields}>
          {title.Clear}
        </Button>
      </div>
    ) : (
      <div className="form_header">
        <Button
          type="primary"
          htmlType="button"
          className="float-right"
          onClick={() => NextPrevSteps(title.Finish)}
        >
          Save
        </Button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <Button type="link" className="float-right" onClick={resetFields}>
          {title.Clear}
        </Button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <Button
          htmlType="button"
          className="float-left"
          onClick={() =>
            NextPrevSteps(currentStep === 0 ? title.Next : title.Previous)
          }
        >
          {currentStep === 0 ? title.Next : title.Previous}
        </Button>
      </div>
    );
  }
}

export default StepsHeader;
